import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=6afcec43&scoped=true&lang=pug&"
import script from "./Draggable.vue?vue&type=script&lang=ts&"
export * from "./Draggable.vue?vue&type=script&lang=ts&"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=6afcec43&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afcec43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSlider,VTextField,VTextarea})
